import gql from 'graphql-tag';

export const RevertContentMutation =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		mutation RevertContentMutation($contentId: ID!) @experimental {
			experimentalRevertContent(contentId: $contentId)
		}
	`;
